import * as Yup from 'yup';
import { t } from 'src/lib/language';

const OrganisationEmailsValidator = (lang: string) => Yup.object().shape({
  receipt_email_title: Yup.string()
    .when('receipt_email_message', {
      is: (val: string) => val && val.length > 0,
      then: (schema) => schema.required(t(lang, 'validations.organisation.email_title_required')),
    })
    .nullable(),
  receipt_email_message: Yup.string()
    .when('receipt_email_title', {
      is: (val: string) => val && val.length > 0,
      then: (schema) => schema.required(t(lang, 'validations.organisation.email_message_required')),
    })
    .nullable(),
  invoice_email_title: Yup.string()
    .when('invoice_email_message', {
      is: (val: string) => val && val.length > 0,
      then: (schema) => schema.required(t(lang, 'validations.organisation.email_title_required')),
    })
    .nullable(),
  invoice_email_message: Yup.string()
    .when('invoice_email_title', {
      is: (val: string) => val && val.length > 0,
      then: (schema) => schema.required(t(lang, 'validations.organisation.email_message_required')),
    })
    .nullable(),
});

export default OrganisationEmailsValidator;
